module.exports = __webpack_public_path__ + "img/91716.604eaf0f.svg";